







import {Component} from 'vue-property-decorator'
import axios from 'axios'
import { apiV1AdminEventPath } from '@/rails/routes'
import Event, {IEvent} from '@/models/Event'
import EventForm from '@/components/admin/events/Form.vue'
import PageBase, {BreadCrumb} from '@/pages/page-base'

@Component({
  components: {
    EventForm
  }
})
export default class EventEdit extends PageBase {
  event = new Event()

  async mounted(): Promise<void> {
    try {
      super.mounted()
      const res = await axios.get<IEvent>(apiV1AdminEventPath(this.$route.params.id))
      this.event = new Event(res.data)
      this.loading = false
    } catch (e) {
      console.error(e)
    }
  }

  async save(): Promise<void> {
    try {
      const res = await axios.put(apiV1AdminEventPath(this.$route.params.id), {
        event: this.event.toParams()
      })
      this.event = new Event(res.data)
      this.showMessage('変更を保存しました。')
      this.$router.push(`/admin/events/${this.event.id}/edit`)
    } catch (e) {
      console.log(e)
    }
  }

  get breadcrumbs(): Array<BreadCrumb> {
    return [
      {
        text: 'イベント一覧',
        to: '/admin/events',
        exact: true
      },
      {
        text: 'イベント編集'
      }
    ]
  }
}
